export enum ProgrammingCapability {
  IS_FETCHING_HIERARCHICAL = 'IS_FETCHING_HIERARCHICAL',
  IS_FETCHING_PERCENTAGE = 'IS_FETCHING_PERCENTAGE',
  IS_FETCHING_VALIDATE = 'IS_FETCHING_VALIDATE',
  IS_FETCHING_UPDATE = 'IS_FETCHING_UPDATE',
}
